import { initStateFromLocation } from "../helpers/initStateFromLocation";
import { State } from "../types/State";

export class Store {
  #state: State;

  constructor() {
    this.#state = initStateFromLocation();
  }

  getState() {
    return this.#state;
  }

  updateState<K extends keyof State>(key: K, value: State[K]) {
    if (Array.isArray(value) && !value.length) delete this.#state[key];
    if (key !== "_page") {
      delete this.#state["_page"];
      this.#state[key] = value;
    }
  }
}
